export default __webpack_public_path__ + "static/artisan-f3b52c1d3931db344c98780911aef63f.jpg";